export const CREATOR_PORTAL_LOCALE_BY_LANGUAGE = {
  EN: 'en-US',
  DE: 'de-DE',
  FR: 'fr-FR',
  ES: 'es-ES',
  KR: 'ko-KR',
};

export const CREATOR_PORTAL_I18N = {
  EN: {
    title: 'Creator Portal',
    myId: 'My ID',
    useAnotherId: 'Use another ID',
    enterMyIdHint: 'Enter your My ID to access your contract, status, invoices and deliverables.',
    sendVerificationCode: 'Send Verification Code',
    sendingCode: 'Sending code...',
    verifyCodeHint: ({ destination }) => `Enter the verification code sent to ${destination || 'your email'}.`,
    verificationCode: 'Verification code',
    verifyCode: 'Verify Code',
    checkingCode: 'Checking...',
    resend: 'Resend',
    backToLogin: 'Back to Login',
    verificationFailedRestart: 'Verification failed. Please restart login and request a new code.',
    campaign: 'Campaign',
    channel: 'Channel',
    currentStatus: 'Current Status',
    creative: 'Creative',
    details: 'Details',
    history: 'History',
    performance: 'Performance',
    latestViews: 'Latest views',
    estimatedViews: 'Estimated views',
    fillrate: 'Fillrate',
    contract: 'Contract',
    noContract: 'No contract file found.',
    additionalVersions: ({ count }) => `Additional versions available: ${count}`,
    deliverables: 'Deliverables',
    deliverablesHint: 'Upload all required deliverables for your media format before uploading an invoice.',
    delivered: 'Delivered',
    missing: 'Missing',
    save: 'Save',
    saving: 'Saving...',
    uploadFile: 'Upload File',
    uploading: 'Uploading...',
    pasteUrl: 'Paste URL',
    value: 'Value',
    integrationTimestamp: 'Integration Timestamp (mm:ss)',
    integrationTimestampPlaceholder: 'e.g. 03:42 or 01:03:42',
    integrationTimestampHint: 'Where in the video the integration starts.',
    invoice: 'Invoice',
    status: 'Status',
    number: 'Number',
    noInvoiceFile: 'No invoice file found yet.',
    uploadInvoice: 'Upload Invoice',
    communication: 'Communication',
    writeMessage: 'Write a message',
    send: 'Send',
    activity: 'Activity Log',
    themeSystem: 'Theme: system',
    themeLight: 'Theme: light',
    themeDark: 'Theme: dark',
    language: 'Language',
    signedInWithActiveSession: 'Signed in with active session.',
    commentSent: 'Comment sent.',
    invoiceUploaded: 'Invoice uploaded.',
    deliverableUploaded: 'Deliverable uploaded.',
    deliverableSaved: ({ label }) => `${label || 'Deliverable'} saved.`,
    loginFailed: ({ message }) => `Login failed: ${message}`,
    verificationFailed: ({ message }) => `Verification failed: ${message}`,
    uploadFailed: ({ message }) => `Upload failed: ${message}`,
    commentSendFailed: ({ message }) => `Could not send comment: ${message}`,
    sessionExpired: 'Your session expired. Please login again.',
    missingVerificationCode: 'Please enter the verification code.',
    enterValueFor: ({ label }) => `Please enter ${label || 'a value'}.`,
    emailAddress: 'Email address',
    missingEmailTitle: 'Email required',
    missingEmailDescription: 'No email was found for this creator. Enter your email address to receive the verification code.',
    timestampFormatError: 'Please use integration timestamp format mm:ss or hh:mm:ss (example: 03:42).',
    loginCodeSent: ({ destination }) => `Verification code sent to ${destination || 'your email'}.`,
    codeEmailSentToX: ({ email }) => `Code email sent to ${email || 'your email'}.`,
    previewNotAvailable: 'Preview is not available.',
    previewNotAvailableForType: 'Preview is not available for this creative type.',
    imagePreviewNotAvailable: 'Image preview is not available.',
    previewBlocked: 'Preview is blocked for this file.',
    openFile: 'Open file',
    drivePreviewFallback: 'Preview could not be loaded. Open the file directly.',
    drivePreviewOpenText: 'Open file',
    noRequiredDeliverables: 'No required deliverables configured for this format. Add one or more rows.',
    showCount: ({ count }) => `${count}x show`,
    hideCount: ({ count }) => `${count}x hide`,
    attachmentPreview: 'Attachment Preview',
    noPreviewAvailable: 'No preview available.',
    loginWithDiscord: 'Login with Discord',
    connectDiscord: 'Connect Discord',
    openingDiscord: 'Opening Discord...',
    discordConnectedAs: ({ name }) => `Discord connected as ${name || 'unknown user'}.`,
    discordNotConnected: 'Discord is not connected yet.',
    discordConnectHint: 'Connect your Discord account to unlock channel-wide activation history.',
    discordConnectSuccess: 'Discord account connected.',
    discordConnectFailed: ({ message }) => `Discord connection failed: ${message}`,
    discordLoginFailed: ({ message }) => `Discord login failed: ${message}`,
    activations: 'Activations',
    myActivations: 'My Activations',
    myActivationsMenuLabel: ({ count }) => `My Activations (${count || 0})`,
    myActivationsDescription: 'Open all activations linked to your channel and jump into any activation detail page.',
    openMyActivations: 'Open My Activations',
    backToActivation: 'Back to Activation',
    activeActivation: 'Active',
    myEarnings: 'My Earnings',
    activationCount: ({ count }) => `${count || 0} activations`,
    noActivationImage: 'No product image',
    accountMenu: 'Account menu',
    logout: 'Logout',
    loggingOut: 'Logging out...',
    loggedOut: 'Logged out.',
    logoutFailed: ({ message }) => `Logout failed: ${message}`,
    selectActivation: 'Select activation',
    noActivations: 'No activations found for this account.',
    switchingActivation: 'Switching activation...',
    activationSwitchFailed: ({ message }) => `Could not switch activation: ${message}`,
  },
  DE: {
    title: 'Creator Portal', myId: 'Meine ID', useAnotherId: 'Andere ID verwenden',
    enterMyIdHint: 'Gib deine ID ein, um Vertrag, Status, Rechnungen und Deliverables zu sehen.',
    sendVerificationCode: 'Verifizierungscode senden', sendingCode: 'Code wird gesendet...',
    verifyCodeHint: ({ destination }) => `Gib den Code ein, der an ${destination || 'deine E-Mail'} gesendet wurde.`,
    verificationCode: 'Verifizierungscode', verifyCode: 'Code prüfen', checkingCode: 'Prüfung...', resend: 'Erneut senden',
    backToLogin: 'Zurück zum Login', verificationFailedRestart: 'Verifizierung fehlgeschlagen. Bitte erneut starten.',
    campaign: 'Kampagne', channel: 'Kanal', currentStatus: 'Aktueller Status', creative: 'Creative',
    details: 'Details', history: 'Historie', performance: 'Performance', latestViews: 'Letzte Views',
    estimatedViews: 'Geschätzte Views', fillrate: 'Fillrate', contract: 'Vertrag', noContract: 'Keine Vertragsdatei gefunden.',
    additionalVersions: ({ count }) => `Weitere Versionen verfügbar: ${count}`, deliverables: 'Deliverables',
    deliverablesHint: 'Lade alle erforderlichen Deliverables hoch, bevor du eine Rechnung hochlädst.',
    delivered: 'Geliefert', missing: 'Fehlt', save: 'Speichern', saving: 'Speichert...', uploadFile: 'Datei hochladen',
    uploading: 'Lädt hoch...', pasteUrl: 'URL einfügen', value: 'Wert', integrationTimestamp: 'Integration-Zeitstempel (mm:ss)',
    integrationTimestampPlaceholder: 'z. B. 03:42 oder 01:03:42', integrationTimestampHint: 'Startzeit der Integration im Video.',
    invoice: 'Rechnung', status: 'Status', number: 'Nummer', noInvoiceFile: 'Noch keine Rechnungsdatei vorhanden.',
    uploadInvoice: 'Rechnung hochladen', communication: 'Kommunikation', writeMessage: 'Nachricht schreiben', send: 'Senden',
    activity: 'Aktivitäten', themeSystem: 'Theme: System', themeLight: 'Theme: Hell', themeDark: 'Theme: Dunkel',
    language: 'Sprache',
    signedInWithActiveSession: 'Mit aktiver Session angemeldet.', commentSent: 'Kommentar gesendet.',
    invoiceUploaded: 'Rechnung hochgeladen.', deliverableUploaded: 'Deliverable hochgeladen.',
    deliverableSaved: ({ label }) => `${label || 'Deliverable'} gespeichert.`, loginFailed: ({ message }) => `Login fehlgeschlagen: ${message}`,
    verificationFailed: ({ message }) => `Verifizierung fehlgeschlagen: ${message}`, uploadFailed: ({ message }) => `Upload fehlgeschlagen: ${message}`,
    commentSendFailed: ({ message }) => `Kommentar konnte nicht gesendet werden: ${message}`,
    sessionExpired: 'Deine Session ist abgelaufen. Bitte erneut anmelden.', missingVerificationCode: 'Bitte den Verifizierungscode eingeben.',
    enterValueFor: ({ label }) => `Bitte ${label || 'einen Wert'} eingeben.`,
    emailAddress: 'E-Mail-Adresse',
    missingEmailTitle: 'E-Mail erforderlich',
    missingEmailDescription: 'Für diesen Creator wurde keine E-Mail gefunden. Bitte gib eine E-Mail-Adresse ein, um den Verifizierungscode zu erhalten.',
    timestampFormatError: 'Bitte Format mm:ss oder hh:mm:ss verwenden (z. B. 03:42).',
    loginCodeSent: ({ destination }) => `Verifizierungscode wurde an ${destination || 'deine E-Mail'} gesendet.`,
    codeEmailSentToX: ({ email }) => `Code-E-Mail wurde an ${email || 'deine E-Mail'} gesendet.`,
    previewNotAvailable: 'Vorschau ist nicht verfügbar.', previewNotAvailableForType: 'Für diesen Creative-Typ ist keine Vorschau verfügbar.',
    imagePreviewNotAvailable: 'Bildvorschau ist nicht verfügbar.', previewBlocked: 'Vorschau für diese Datei ist blockiert.',
    openFile: 'Datei öffnen', drivePreviewFallback: 'Vorschau konnte nicht geladen werden. Datei direkt öffnen.',
    drivePreviewOpenText: 'Datei öffnen', noRequiredDeliverables: 'Für dieses Format sind keine Pflicht-Deliverables konfiguriert.',
    showCount: ({ count }) => `${count}x anzeigen`,
    hideCount: ({ count }) => `${count}x ausblenden`,
    attachmentPreview: 'Anhangsvorschau',
    noPreviewAvailable: 'Keine Vorschau verfügbar.',
    loginWithDiscord: 'Mit Discord einloggen',
    connectDiscord: 'Discord verbinden',
    openingDiscord: 'Discord wird geöffnet...',
    discordConnectedAs: ({ name }) => `Discord verbunden als ${name || 'unbekannter User'}.`,
    discordNotConnected: 'Discord ist noch nicht verbunden.',
    discordConnectHint: 'Verbinde dein Discord-Konto, um die Channel-Historie aller Activations zu sehen.',
    discordConnectSuccess: 'Discord-Konto verbunden.',
    discordConnectFailed: ({ message }) => `Discord-Verbindung fehlgeschlagen: ${message}`,
    discordLoginFailed: ({ message }) => `Discord-Login fehlgeschlagen: ${message}`,
    activations: 'Activations',
    myActivations: 'Meine Activations',
    myActivationsMenuLabel: ({ count }) => `Meine Activations (${count || 0})`,
    myActivationsDescription: 'Öffne alle Activations deines Channels und springe direkt in die jeweilige Detailansicht.',
    openMyActivations: 'Meine Activations öffnen',
    backToActivation: 'Zurück zur Activation',
    activeActivation: 'Aktiv',
    myEarnings: 'My Earnings',
    activationCount: ({ count }) => `${count || 0} Activations`,
    noActivationImage: 'Kein Produktbild',
    accountMenu: 'Account-Menü',
    logout: 'Logout',
    loggingOut: 'Logout läuft...',
    loggedOut: 'Ausgeloggt.',
    logoutFailed: ({ message }) => `Logout fehlgeschlagen: ${message}`,
    selectActivation: 'Activation wählen',
    noActivations: 'Keine Activations für dieses Konto gefunden.',
    switchingActivation: 'Activation wird gewechselt...',
    activationSwitchFailed: ({ message }) => `Activation konnte nicht gewechselt werden: ${message}`,
  },
  FR: {
    title: 'Creator Portal', myId: 'Mon ID', useAnotherId: 'Utiliser un autre ID',
    enterMyIdHint: 'Saisissez votre ID pour accéder au contrat, statut, factures et livrables.',
    sendVerificationCode: 'Envoyer le code', sendingCode: 'Envoi du code...',
    verifyCodeHint: ({ destination }) => `Saisissez le code envoyé à ${destination || 'votre e-mail'}.`,
    verificationCode: 'Code de vérification', verifyCode: 'Vérifier', checkingCode: 'Vérification...', resend: 'Renvoyer',
    backToLogin: 'Retour à la connexion', verificationFailedRestart: 'Échec de vérification. Veuillez recommencer.',
    campaign: 'Campagne', channel: 'Chaîne', currentStatus: 'Statut actuel', creative: 'Créatif', details: 'Détails', history: 'Historique',
    performance: 'Performance', latestViews: 'Dernières vues', estimatedViews: 'Vues estimées', fillrate: 'Taux de remplissage',
    contract: 'Contrat', noContract: 'Aucun fichier de contrat trouvé.', additionalVersions: ({ count }) => `Versions supplémentaires: ${count}`,
    deliverables: 'Livrables', deliverablesHint: 'Téléchargez tous les livrables requis avant la facture.', delivered: 'Livré', missing: 'Manquant',
    save: 'Enregistrer', saving: 'Enregistrement...', uploadFile: 'Télécharger un fichier', uploading: 'Téléchargement...',
    pasteUrl: 'Coller URL', value: 'Valeur', integrationTimestamp: 'Horodatage d’intégration (mm:ss)',
    integrationTimestampPlaceholder: 'ex. 03:42 ou 01:03:42', integrationTimestampHint: 'Moment où l’intégration commence dans la vidéo.',
    invoice: 'Facture', status: 'Statut', number: 'Numéro', noInvoiceFile: 'Aucun fichier de facture trouvé.', uploadInvoice: 'Télécharger la facture',
    communication: 'Communication', writeMessage: 'Écrire un message', send: 'Envoyer', activity: 'Activité',
    themeSystem: 'Thème: système', themeLight: 'Thème: clair', themeDark: 'Thème: sombre',
    language: 'Langue',
    signedInWithActiveSession: 'Connecté avec une session active.', commentSent: 'Commentaire envoyé.', invoiceUploaded: 'Facture téléchargée.',
    deliverableUploaded: 'Livrable téléchargé.', deliverableSaved: ({ label }) => `${label || 'Livrable'} enregistré.`,
    loginFailed: ({ message }) => `Échec de connexion: ${message}`, verificationFailed: ({ message }) => `Échec de vérification: ${message}`,
    uploadFailed: ({ message }) => `Échec du téléchargement: ${message}`, commentSendFailed: ({ message }) => `Impossible d’envoyer: ${message}`,
    sessionExpired: 'Votre session a expiré. Reconnectez-vous.', missingVerificationCode: 'Veuillez saisir le code de vérification.',
    enterValueFor: ({ label }) => `Veuillez saisir ${label || 'une valeur'}.`,
    emailAddress: 'Adresse e-mail',
    missingEmailTitle: 'E-mail requis',
    missingEmailDescription: 'Aucun e-mail trouvé pour ce créateur. Saisissez une adresse e-mail pour recevoir le code de vérification.',
    timestampFormatError: 'Utilisez le format mm:ss ou hh:mm:ss (ex: 03:42).',
    loginCodeSent: ({ destination }) => `Code envoyé à ${destination || 'votre e-mail'}.`, previewNotAvailable: 'Aperçu indisponible.',
    codeEmailSentToX: ({ email }) => `Code envoyé par e-mail à ${email || 'votre e-mail'}.`,
    previewNotAvailableForType: 'Aperçu indisponible pour ce type de créatif.', imagePreviewNotAvailable: 'Aperçu de l’image indisponible.',
    previewBlocked: 'Aperçu bloqué pour ce fichier.', openFile: 'Ouvrir le fichier',
    drivePreviewFallback: 'Aperçu non chargé. Ouvrez le fichier directement.', drivePreviewOpenText: 'Ouvrir le fichier',
    noRequiredDeliverables: 'Aucun livrable requis configuré pour ce format.',
    showCount: ({ count }) => `${count}x afficher`,
    hideCount: ({ count }) => `${count}x masquer`,
    attachmentPreview: 'Aperçu de la pièce jointe',
    noPreviewAvailable: 'Aucun aperçu disponible.',
    loginWithDiscord: 'Login with Discord',
    connectDiscord: 'Connect Discord',
    openingDiscord: 'Opening Discord...',
    discordConnectedAs: ({ name }) => `Discord connected as ${name || 'unknown user'}.`,
    discordNotConnected: 'Discord is not connected yet.',
    discordConnectHint: 'Connect your Discord account to unlock channel-wide activation history.',
    discordConnectSuccess: 'Discord account connected.',
    discordConnectFailed: ({ message }) => `Discord connection failed: ${message}`,
    discordLoginFailed: ({ message }) => `Discord login failed: ${message}`,
    activations: 'Activations',
    myActivations: 'My Activations',
    myActivationsMenuLabel: ({ count }) => `My Activations (${count || 0})`,
    myActivationsDescription: 'Open all activations linked to your channel and jump into any activation detail page.',
    openMyActivations: 'Open My Activations',
    backToActivation: 'Back to Activation',
    activeActivation: 'Active',
    myEarnings: 'My Earnings',
    activationCount: ({ count }) => `${count || 0} activations`,
    noActivationImage: 'No product image',
    accountMenu: 'Account menu',
    logout: 'Logout',
    loggingOut: 'Logging out...',
    loggedOut: 'Logged out.',
    logoutFailed: ({ message }) => `Logout failed: ${message}`,
    selectActivation: 'Select activation',
    noActivations: 'No activations found for this account.',
    switchingActivation: 'Switching activation...',
    activationSwitchFailed: ({ message }) => `Could not switch activation: ${message}`,
  },
  ES: {
    title: 'Creator Portal', myId: 'Mi ID', useAnotherId: 'Usar otro ID',
    enterMyIdHint: 'Introduce tu ID para acceder al contrato, estado, facturas y entregables.',
    sendVerificationCode: 'Enviar código', sendingCode: 'Enviando código...',
    verifyCodeHint: ({ destination }) => `Introduce el código enviado a ${destination || 'tu correo'}.`,
    verificationCode: 'Código de verificación', verifyCode: 'Verificar', checkingCode: 'Verificando...', resend: 'Reenviar',
    backToLogin: 'Volver al inicio', verificationFailedRestart: 'Falló la verificación. Inicia de nuevo.', campaign: 'Campaña', channel: 'Canal',
    currentStatus: 'Estado actual', creative: 'Creativo', details: 'Detalles', history: 'Historial', performance: 'Rendimiento',
    latestViews: 'Últimas vistas', estimatedViews: 'Vistas estimadas', fillrate: 'Fillrate', contract: 'Contrato',
    noContract: 'No se encontró contrato.', additionalVersions: ({ count }) => `Versiones adicionales: ${count}`,
    deliverables: 'Entregables', deliverablesHint: 'Sube todos los entregables requeridos antes de la factura.', delivered: 'Entregado',
    missing: 'Faltante', save: 'Guardar', saving: 'Guardando...', uploadFile: 'Subir archivo', uploading: 'Subiendo...', pasteUrl: 'Pegar URL',
    value: 'Valor', integrationTimestamp: 'Marca de integración (mm:ss)', integrationTimestampPlaceholder: 'ej. 03:42 o 01:03:42',
    integrationTimestampHint: 'Momento donde empieza la integración en el video.', invoice: 'Factura', status: 'Estado', number: 'Número',
    noInvoiceFile: 'Aún no hay archivo de factura.', uploadInvoice: 'Subir factura', communication: 'Comunicación',
    writeMessage: 'Escribe un mensaje', send: 'Enviar', activity: 'Actividad', themeSystem: 'Tema: sistema', themeLight: 'Tema: claro',
    themeDark: 'Tema: oscuro', signedInWithActiveSession: 'Sesión activa restaurada.', commentSent: 'Comentario enviado.',
    language: 'Idioma',
    invoiceUploaded: 'Factura subida.', deliverableUploaded: 'Entregable subido.', deliverableSaved: ({ label }) => `${label || 'Entregable'} guardado.`,
    loginFailed: ({ message }) => `Error de acceso: ${message}`, verificationFailed: ({ message }) => `Error de verificación: ${message}`,
    uploadFailed: ({ message }) => `Error de subida: ${message}`, commentSendFailed: ({ message }) => `No se pudo enviar: ${message}`,
    sessionExpired: 'Tu sesión expiró. Inicia sesión otra vez.', missingVerificationCode: 'Introduce el código de verificación.',
    enterValueFor: ({ label }) => `Introduce ${label || 'un valor'}.`, timestampFormatError: 'Usa formato mm:ss o hh:mm:ss (ejemplo: 03:42).',
    loginCodeSent: ({ destination }) => `Código enviado a ${destination || 'tu correo'}.`, previewNotAvailable: 'Vista previa no disponible.',
    emailAddress: 'Correo electrónico',
    missingEmailTitle: 'Correo requerido',
    missingEmailDescription: 'No se encontró correo para este creador. Introduce un correo para recibir el código de verificación.',
    codeEmailSentToX: ({ email }) => `Correo con el código enviado a ${email || 'tu correo'}.`,
    previewNotAvailableForType: 'Vista previa no disponible para este tipo de creativo.', imagePreviewNotAvailable: 'Vista previa de imagen no disponible.',
    previewBlocked: 'Vista previa bloqueada para este archivo.', openFile: 'Abrir archivo',
    drivePreviewFallback: 'No se pudo cargar la vista previa. Abre el archivo directamente.', drivePreviewOpenText: 'Abrir archivo',
    noRequiredDeliverables: 'No hay entregables obligatorios configurados para este formato.',
    showCount: ({ count }) => `${count}x mostrar`,
    hideCount: ({ count }) => `${count}x ocultar`,
    attachmentPreview: 'Vista previa del adjunto',
    noPreviewAvailable: 'No hay vista previa disponible.',
    loginWithDiscord: 'Login with Discord',
    connectDiscord: 'Connect Discord',
    openingDiscord: 'Opening Discord...',
    discordConnectedAs: ({ name }) => `Discord connected as ${name || 'unknown user'}.`,
    discordNotConnected: 'Discord is not connected yet.',
    discordConnectHint: 'Connect your Discord account to unlock channel-wide activation history.',
    discordConnectSuccess: 'Discord account connected.',
    discordConnectFailed: ({ message }) => `Discord connection failed: ${message}`,
    discordLoginFailed: ({ message }) => `Discord login failed: ${message}`,
    activations: 'Activations',
    myActivations: 'My Activations',
    myActivationsMenuLabel: ({ count }) => `My Activations (${count || 0})`,
    myActivationsDescription: 'Open all activations linked to your channel and jump into any activation detail page.',
    openMyActivations: 'Open My Activations',
    backToActivation: 'Back to Activation',
    activeActivation: 'Active',
    myEarnings: 'My Earnings',
    activationCount: ({ count }) => `${count || 0} activations`,
    noActivationImage: 'No product image',
    accountMenu: 'Account menu',
    logout: 'Logout',
    loggingOut: 'Logging out...',
    loggedOut: 'Logged out.',
    logoutFailed: ({ message }) => `Logout failed: ${message}`,
    selectActivation: 'Select activation',
    noActivations: 'No activations found for this account.',
    switchingActivation: 'Switching activation...',
    activationSwitchFailed: ({ message }) => `Could not switch activation: ${message}`,
  },
  KR: {
    title: '크리에이터 포털', myId: '내 ID', useAnotherId: '다른 ID 사용',
    enterMyIdHint: '내 ID를 입력해 계약, 상태, 인보이스, 딜리버러블을 확인하세요.',
    sendVerificationCode: '인증 코드 전송', sendingCode: '코드 전송 중...',
    verifyCodeHint: ({ destination }) => `${destination || '이메일'}로 전송된 인증 코드를 입력하세요.`,
    verificationCode: '인증 코드', verifyCode: '코드 확인', checkingCode: '확인 중...', resend: '재전송',
    backToLogin: '로그인으로 돌아가기', verificationFailedRestart: '인증에 실패했습니다. 다시 시도하세요.',
    campaign: '캠페인', channel: '채널', currentStatus: '현재 상태', creative: '크리에이티브', details: '상세', history: '히스토리',
    performance: '성과', latestViews: '최신 조회수', estimatedViews: '예상 조회수', fillrate: '충족률', contract: '계약서',
    noContract: '계약 파일이 없습니다.', additionalVersions: ({ count }) => `추가 버전: ${count}`,
    deliverables: '딜리버러블', deliverablesHint: '인보이스 업로드 전에 필수 딜리버러블을 모두 제출하세요.',
    delivered: '제출됨', missing: '미제출', save: '저장', saving: '저장 중...', uploadFile: '파일 업로드', uploading: '업로드 중...',
    pasteUrl: 'URL 붙여넣기', value: '값', integrationTimestamp: '통합 타임스탬프 (mm:ss)',
    integrationTimestampPlaceholder: '예: 03:42 또는 01:03:42', integrationTimestampHint: '영상에서 통합이 시작되는 시점.',
    invoice: '인보이스', status: '상태', number: '번호', noInvoiceFile: '인보이스 파일이 아직 없습니다.', uploadInvoice: '인보이스 업로드',
    communication: '커뮤니케이션', writeMessage: '메시지 작성', send: '전송', activity: '활동',
    themeSystem: '테마: 시스템', themeLight: '테마: 라이트', themeDark: '테마: 다크',
    language: '언어',
    signedInWithActiveSession: '활성 세션으로 로그인되었습니다.', commentSent: '메시지를 전송했습니다.',
    invoiceUploaded: '인보이스가 업로드되었습니다.', deliverableUploaded: '딜리버러블이 업로드되었습니다.',
    deliverableSaved: ({ label }) => `${label || '딜리버러블'} 저장 완료.`, loginFailed: ({ message }) => `로그인 실패: ${message}`,
    verificationFailed: ({ message }) => `인증 실패: ${message}`, uploadFailed: ({ message }) => `업로드 실패: ${message}`,
    commentSendFailed: ({ message }) => `메시지 전송 실패: ${message}`,
    sessionExpired: '세션이 만료되었습니다. 다시 로그인하세요.', missingVerificationCode: '인증 코드를 입력하세요.',
    enterValueFor: ({ label }) => `${label || '값'}을(를) 입력하세요.`, timestampFormatError: 'mm:ss 또는 hh:mm:ss 형식을 사용하세요 (예: 03:42).',
    loginCodeSent: ({ destination }) => `${destination || '이메일'}로 인증 코드를 보냈습니다.`, previewNotAvailable: '미리보기를 사용할 수 없습니다.',
    emailAddress: '이메일 주소',
    missingEmailTitle: '이메일 필요',
    missingEmailDescription: '이 크리에이터에 등록된 이메일이 없습니다. 인증 코드를 받을 이메일 주소를 입력하세요.',
    codeEmailSentToX: ({ email }) => `코드 이메일을 ${email || '이메일'}로 보냈습니다.`,
    previewNotAvailableForType: '이 크리에이티브 유형은 미리보기를 지원하지 않습니다.', imagePreviewNotAvailable: '이미지 미리보기를 불러올 수 없습니다.',
    previewBlocked: '이 파일은 미리보기가 차단되었습니다.', openFile: '파일 열기',
    drivePreviewFallback: '미리보기를 불러올 수 없습니다. 파일을 직접 여세요.', drivePreviewOpenText: '파일 열기',
    noRequiredDeliverables: '이 형식에 설정된 필수 딜리버러블이 없습니다.',
    showCount: ({ count }) => `${count}회 표시`,
    hideCount: ({ count }) => `${count}회 숨기기`,
    attachmentPreview: '첨부 미리보기',
    noPreviewAvailable: '미리보기를 사용할 수 없습니다.',
    loginWithDiscord: 'Login with Discord',
    connectDiscord: 'Connect Discord',
    openingDiscord: 'Opening Discord...',
    discordConnectedAs: ({ name }) => `Discord connected as ${name || 'unknown user'}.`,
    discordNotConnected: 'Discord is not connected yet.',
    discordConnectHint: 'Connect your Discord account to unlock channel-wide activation history.',
    discordConnectSuccess: 'Discord account connected.',
    discordConnectFailed: ({ message }) => `Discord connection failed: ${message}`,
    discordLoginFailed: ({ message }) => `Discord login failed: ${message}`,
    activations: 'Activations',
    myActivations: 'My Activations',
    myActivationsMenuLabel: ({ count }) => `My Activations (${count || 0})`,
    myActivationsDescription: 'Open all activations linked to your channel and jump into any activation detail page.',
    openMyActivations: 'Open My Activations',
    backToActivation: 'Back to Activation',
    activeActivation: 'Active',
    myEarnings: 'My Earnings',
    activationCount: ({ count }) => `${count || 0} activations`,
    noActivationImage: 'No product image',
    accountMenu: 'Account menu',
    logout: 'Logout',
    loggingOut: 'Logging out...',
    loggedOut: 'Logged out.',
    logoutFailed: ({ message }) => `Logout failed: ${message}`,
    selectActivation: 'Select activation',
    noActivations: 'No activations found for this account.',
    switchingActivation: 'Switching activation...',
    activationSwitchFailed: ({ message }) => `Could not switch activation: ${message}`,
  },
};

export const getCreatorPortalText = (language = 'EN') =>
  CREATOR_PORTAL_I18N[language] || CREATOR_PORTAL_I18N.EN;

export const formatCreatorPortalDateTime = (value, language = 'EN') => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';

  const locale = CREATOR_PORTAL_LOCALE_BY_LANGUAGE[language] || 'en-US';
  const day = new Intl.DateTimeFormat(locale, { day: '2-digit' }).format(date);
  const monthRaw = new Intl.DateTimeFormat(locale, { month: 'short' }).format(date);
  const month = String(monthRaw || '').replace('.', '').slice(0, 3);
  const year = new Intl.DateTimeFormat(locale, { year: 'numeric' }).format(date);
  const hour = new Intl.DateTimeFormat(locale, { hour: '2-digit', hour12: false }).format(date);
  const minute = new Intl.DateTimeFormat(locale, { minute: '2-digit' }).format(date);

  return `${day}/${month}/${year}, ${hour}:${minute}`;
};
